/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 6/23/2023
 */
import { Card, CardHeader, Tooltip, Grow,Box } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import Helpers from "../../../../base/utils/Helpers"
import Avatar from "@mui/material/Avatar"
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove"
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck"
import CircularProgress from "@mui/material/CircularProgress"
import "../styles/org.styles.scss" 

const PendingItemBody = (props) => {
  return (
    <Grow in={true} className="transformOrigin" timeout={1000}>
      <Card sx={{ maxWidth: 450, width: 450, boxShadow: 3 }}>
        <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: "red"[500] }} aria-label="recipe">
              {props.name &&
                Helpers.firstLetterFormat(
                  Helpers.underscoreRoleFormat(props.name)
                )}
            </Avatar>
          }
          title={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
               
              }}
            >
              <Tooltip title={Helpers.underscoreRoleFormat(props.name)}>
                <h5
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "150px",
                    cursor:"pointer"
                  }}
                >
                  {Helpers.underscoreRoleFormat(props.name)}
                </h5>
              </Tooltip>
            </Box>
          }
          subheader={Helpers.underscoreRoleFormat(props.action)}
          action={
            <div>
              {props.isBtnLoading === false ? (
                <div>
                  <Tooltip title="Accept">
                    <IconButton
                      onClick={() => props.handleAccept(props?.approveId)}
                      aria-label="Accept"
                    >
                      <PlaylistAddCheckIcon fontSize="large" color="success" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Reject">
                    <IconButton
                      onClick={() => props.handleReject(props?.approveId)}
                      aria-label="Reject"
                    >
                      <PlaylistRemoveIcon fontSize="large" color="error" />
                    </IconButton>
                  </Tooltip>
                </div>
              ) : (
                <CircularProgress
                  sx={{ marginTop: "10px", marginRight: "25px" }}
                  size={20}
                />
              )}
            </div>
          }
        />
      </Card>
    </Grow>
  )
}

export default PendingItemBody
